// © Microsoft Corporation. All rights reserved.

import {
    DesignSystem,
    neutralFillStealthHover,
    neutralForegroundHint,
    neutralForegroundRest,
    neutralLayerCard
} from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";
import { enums } from "../../../utils/enums";

const avatarSize = "54px";
const avatarSizeL0 = "78px"; // responsıve level 0
const sidePadding = "10px";
const buttonHeight = "36px";
const borderColor = "#DDDDDD";
const inReviewMarkColor = "#FFB900";
const notAllowMarkColor = "#E22C3B";
const markSize = 20;

export const PublisherProfileCardStatsStyles = (config: DesignSystem) => ({
    publisherProfileCardStatsContainer: {
        display: "flex",
        "justify-content": "center",

        "& .cwt-stat": {
            "margin-top": "10px",
            display: "flex",
            "flex-direction": "column",
            "align-items": "center",
            "justify-content": "flex-start",

            "& .cwt-stat-counter ": {
                "font-size": "14px"
            }
        }
    },

    followersDefinitionPopoverContainer: {
        bottom: "25px",
        [applyLocalizedProperty(
            "left",
            "right",
            config.direction
        )]: "5px"
    }
});
